// Mirrors backend App\Enums\Payment\AccountSessionComponent

export type AccountSessionComponent = 'account_onboarding' | 'account_management'

export const AccountSessionComponent = {
  ACCOUNT_ONBOARDING: 'account_onboarding',
  ACCOUNT_MANAGEMENT: 'account_management'
} satisfies Record<string, AccountSessionComponent>

export const AccountSessionComponentValues: readonly AccountSessionComponent[] =
  Object.values(AccountSessionComponent)
